import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { RefObject, useEffect } from 'react'
import { Icons } from '@components/gassan-ui'
import { MembershipPageType } from '..'

type LocalizedItem = {
  pageTitle: string
  title: string
  url: string
}

type LocalizedItems = {
  [key in MembershipPageType]: LocalizedItem
}

type NavItem = {
  key: MembershipPageType
  icon: keyof Icons
}

export const navItems: NavItem[] = [
  {
    key: 'overview',
    icon: 'diamond',
  },
  {
    key: 'my-membership',
    icon: 'account-my-gassan',
  },
  {
    key: 'privileges',
    icon: 'account-star',
  },
  {
    key: 'orders',
    icon: 'account-order',
  },
  {
    key: 'services',
    icon: 'account-service',
  },
  {
    key: 'documents',
    icon: 'account-document',
  },
  {
    key: 'wishlist',
    icon: 'account-heart',
  },
  {
    key: 'giftcards',
    icon: 'account-giftcard',
  },
  {
    key: 'preferences',
    icon: 'account-check',
  },
]

export function useMembershipNavigation(parentRef: RefObject<HTMLDivElement>) {
  const { prefetch } = useRouter()
  const { t } = useTranslation('navigation')
  const localizedNavItems = t<string, LocalizedItems>('membership', {
    ns: 'navigation',
    returnObjects: true,
  })

  useEffect(() => {
    // Nextjs automatically prefetches links in the viewport,
    // but some items might not be in the viewport, so we prefetch them all here.
    if (navItems) {
      navItems.forEach((pageType) => {
        prefetch(localizedNavItems[pageType.key]?.url)
      })
    }
  }, [prefetch, localizedNavItems])

  function scrollToEnd() {
    parentRef.current?.scrollTo({
      left: parentRef.current?.scrollWidth,
      behavior: 'smooth',
    })
  }

  return {
    navItems,
    localizedNavItems,
    scrollToEnd,
  }
}
